<template>
  <div class="container">
    <div class="list">
      <div class="list__header">
        <div class="list__row">
          <div class="list__col">文本</div>
          <div class="list__col">比重</div>
          <div class="list__col">颜色</div>
          <div
            class="list__col"
            @click.stop="showFontFamilyPopup($event)"
          >
            字体
            <i class="triangle-icon"></i>
          </div>
        </div>
      </div>
      <div class="list__content">
        <div
          class="list__row true-row"
          :class="{'y-1': i === 0}"
          v-for="(item, i) in list"
          :key="i"
          :data-row="i"
        >
          <div
            v-for="(prop, key) in item"
            :key="key"
            class="list__col"
            :data-key="key"
          >
            <input
              v-model.number="prop.value"
              class="list__input"
              :class="{[`key-${key}`]: true, 'color-active': key === 'color' || key === 'font' && currentFont && currentFont.value}"
              :style="{'caret-color': key === 'color' && prop.value !== '默认' ? 'transparent' : 'auto'}"
              :readonly="key === 'font'"
              :type="key === 'size' ? 'number' : 'text'"
              maxlength="10"
              @focus="onInputFocus($event)"
              @blur="onInputBlur($event)"
              @keydown.stop.enter="onEnter($event)"
            />

            <div
              v-if="key === 'color'"
              class="list__color"
              :class="{disabled: defaultFontColor}"
              @click.stop="focusInput($event);showColorPicker($event, prop.value, i)"
            >
              <template v-if="defaultFontColor">
                <el-tooltip
                  effect="dark"
                  content="您已在样式栏选中默认字体颜色"
                >
                  <div
                    :style="{backgroundColor: prop.value}"
                  >{{prop.value !== '默认' ? '' : prop.value}}</div>
                </el-tooltip>
              </template>
              <template v-else>
                <div
                  :style="{backgroundColor: prop.value}"
                >{{prop.value !== '默认' ? '' : prop.value}}</div>
              </template>
            </div>

            <div
              v-if="key === 'font' && currentFont"
              class="font-thumb-wrapper"
              style="text-align: left; padding-left: 1em;"
              @click="focusInput($event)"
            >
              <!-- <img class="font-thumb" :src="$handleAssetsUrl(currentFont.fontUrl)" /> -->
              <span :style="{fontFamily: getFilename(currentFont)}">{{currentFont.label}}</span>
            </div>
          </div>
        </div>

        <div
          class="list__row"
          data-row="-2"
        >
          <div class="list__col">
            <input
              class="list__input"
              type="text"
              placeholder="请输入文本"
              maxlength="10"
              style="width: 252px; marginLeft: 1px;"
              @focus="onInputFocus($event)"
              @blur="onAddInputBlur($event)"
              @keydown.stop.enter="onEnter($event)"
              ref="addTextRef"
            />
          </div>
          <div class="list__col"></div>
          <div class="list__col"></div>
          <div class="list__col"></div>
        </div>
      </div>
      <div class="hr"></div>
    </div>
    <div class="footer">
      <div
        class="btn intereact-grey"
        @click="showModal('wordCloud.importText')"
      >
        <i class="icon icon-file"></i>导入文本
      </div>
      <div
        class="btn intereact-grey"
        @click="addRow()"
      >
        <i class="icon icon-add"></i>新增
      </div>
      <div
        class="btn intereact-grey"
        @click="removeCurrentRows()"
      >
        <i class="icon icon-delete"></i>删除
      </div>
      <div
        class="btn intereact-grey"
        @click="reset()"
      >
        <i class="icon icon-reset"></i>重置
      </div>
    </div>
  </div>
</template>

<script>
const DEF_COLOR = '#5778FB';
const DEF_LIST = [
  {
    text: { value: '视频' },
    size: { value: 1 },
    color: { value: DEF_COLOR },
    font: { value: '默认' }
  },
  {
    text: { value: '手绘' },
    size: { value: 1 },
    color: { value: DEF_COLOR },
    font: { value: '默认' }
  }
];
function makeArr (start, end) {
  let arr = [];
  for (let i = start; i <= end; i++) {
    arr.push(i);
  }
  return arr;
}

export default {
  data () {
    return {
      defaultFontColor: false,
      list: DEF_LIST,
      currentRows: [],
      currentRow: -1,
      ctrlPressed: false,
      shiftPressed: false,
      currentFont: {
        value: '2018-5-16/1526467728442.TTF',
        filename: '1526467728442.TTF',
        label: '方正黑体'
      }
    };
  },
  watch: {
    // list: {
    //   handler (val) {
    //     this.list = val.filter(item => item.text.value)
    //   },
    //   deep: true
    // },

    currentFont (val) {
      this.list.forEach(item => {
        let font = val ? val.value : '默认';
        item.font = font;
      });
    }
  },
  created () {
    this.$bus.on(`cloud.colorPickerConfirm`, (obj, data) => {
      if (data.from === 'textControl') {
        let color = this.list[data.row].color;
        this.$set(color, 'value', obj.hex);
      }
    });

    this.$bus.on('wordCloud.sendImportText', (list) => {
      this.importText(list);
    });

    this.$bus.on('font', (font, from) => {
      if (from === 'wordCloud') {
        let filename = font.value.replace(/.+\//, '');
        this.currentFont = {
          ...font,
          filename
        };
      }
    });

    this.$bus.once('fontFamily.getFontsFirst', (data) => {
      // let filename = data[0].url.replace(/.+\//, '');
      // data = data[0];
      // let font = {}
      // font.filename = filename;
      // font.url = data.url;
      // font.value = data.url;
      // font.fontUrl = data.fontUrl;
      // font.title = data.title;
      // font.label = data.title;

      this.resetFont();
    });

    this.$bus.on('worlCloud.defaultFontColor', (val) => {
      this.defaultFontColor = val;
    });
  },
  mounted () {
    document.addEventListener('keydown', this.onKeydownC);
    document.addEventListener('keyup', this.onKeyupC);
  },
  methods: {
    getFilename (font) {
      return '"' + font.filename + '"';
    },
    resetFont () {
      let font = {};
      font.value = font.url = '2018-5-16/1526467728442.TTF';
      font.filename = '1526467728442.TTF';
      font.title = font.label = '方正黑体';
      this.currentFont = font;
    },
    onInputFocus (ev) {
      const vm = this;
      let $row = $(ev.currentTarget).closest('.list__row');
      let rowIndex = $row.data('row') - 0;
      if (rowIndex != null && this.ctrlPressed && !this.shiftPressed) {
        this.currentRows.push(rowIndex);
        $row.addClass('active');
      } else if (rowIndex != null && this.shiftPressed && !this.ctrlPressed) {
        let min = Math.min(this.currentRow, rowIndex);
        let max = Math.max(this.currentRow, rowIndex);
        let shifted = makeArr(min, max);
        this.currentRows = [...this.currentRows, ...shifted];
        $row.parent().find('.list__row').each((i, el) => {
          let $el = $(el);
          let row = $el.data('row');
          if (vm.currentRows.indexOf(row) > -1) {
            $el.addClass('active');
          } else {
            $el.removeClass('active');
          }
        });
      } else if (rowIndex != null) {
        this.currentRows = [rowIndex];
        $row.addClass('active').siblings().removeClass('active');
      }

      this.currentRow = rowIndex;
    },
    onInputBlur (ev) {
      this.list = this.list.filter((item, i) => {
        let num = +item.size.value;
        let v = item.size.value | 0;

        if (!item.size.value || !v || isNaN(num)) {
          this.$set(item.size, 'value', 1);
        }

        if (item.size.value > 10) {
          this.$set(item.size, 'value', 10);
        } else if (item.size.value < 1) {
          this.$set(item.size, 'value', 0);
        }

        if (!item.text.value) {
          this.currentRow = i - 1;
        }
        return item.text.value;
      });
    },
    onAddInputBlur (ev) {
      let text = ev.target.value;
      if (!text) {
        return;
      }
      ev.target.value = '';
      this.list.push({
        text: { value: text },
        size: { value: 1 },
        color: { value: DEF_COLOR },
        font: this.currentFont || { value: '默认' }
      });
    },
    focusInput (ev) {
      $(ev.currentTarget).prev()[0].focus();
    },
    showColorPicker (ev, color, row) {
      if (this.defaultFontColor) {
        return;
      }
      let el = ev.currentTarget;
      let rect = el.getBoundingClientRect();
      this.$bus.emit('FeaturesPop_vue', {
        name: 'color-cloud',
        // 使用了mixins popup.vue 下两字段就非必传
        posx: rect.left + rect.width - 16,
        posy: rect.top,
        type: 1,
        hasEyedropper: false,
        color: color || DEF_COLOR,
        row,
        from: 'textControl'
        // source: this,
        // whichPart,
      });

      this.$analysis('word_cloud,click_text_color，文字云_点击_文本_颜色');
    },
    showFontFamilyPopup (ev) {
      let el = ev.currentTarget;
      let rect = el.getBoundingClientRect();
      this.$bus.emit('FeaturesPop_vue', {
        name: 'fontFamily',
        initialX: rect.left,
        initialY: rect.top + 10,
        posx: rect.left,
        posy: rect.top + 10,
        type: 1,
        // sprite: this.sprite,
        // source: this.$parent
        from: 'wordCloud',
        refFont: this.currentFont
      });

      this.$analysis('word_cloud,click_text_font，文字云_点击_文本_字体');
    },
    showModal (name) {
      this.$modal.show(name);
      this.$analysis('word_cloud,click_text_import，文字云_点击_文本_导入文本');
    },
    importText (list) {
      list.forEach(item => {
        let { text, size } = item;
        this.list.push({
          text: { value: text },
          size: { value: size },
          color: { value: DEF_COLOR },
          font: this.currentFont || { value: '默认' }
        });
      });
      window.$kk = this.list;
    },
    addRow () {
      if (this.currentRow < 0) {
        this.$refs.addTextRef.focus();
        this.currentRows = [];
        return;
      }
      this.list.splice(this.currentRow + 1, 0, {
        text: { value: '' },
        size: { value: 1 },
        color: { value: DEF_COLOR },
        font: this.currentFont || { value: '默认' }
      });

      this.$nextTick(() => {
        $(this.$el).find('.true-row').eq(this.currentRow + 1).find('input')[0].focus();
      });

      this.currentRows = [this.currentRow];

      this.$analysis('word_cloud,click_text_creat，文字云_点击_文本_新增');
    },
    removeCurrentRows () {
      if (this.currentRow < 0) {
        return;
      }
      this.currentRows.filter(r => r > -1).map(rowIndex => {
        this.list[rowIndex].text.remove = true;
      });
      this.list = this.list.filter(item => !item.text.remove);
      this.currentRows = [this.currentRows];
      if (!this.list.length) {
        this.currentRows = [];
        this.currentRow = -1;
      }

      this.$analysis('word_cloud,click_text_delete，文字云_点击_文本_删除');
    },
    reset () {
      this.$modal.show('wordCloud.confirm', {
        name: 'resetText',
        text: '您确定要重置，清除所有文字吗？',
        reset: true
      });
      this.$bus.once('wordCloud.confirm.do', (thing) => {
        if (thing.name === 'resetText') {
          this.list = [];
          this.resetFont();
          this.defaultFontColor = false;
          this.currentRows = [];
          this.currentRow = -1;
        }
      });

      this.$analysis('word_cloud,click_text_reset，文字云_点击_文本_重置');
    },
    doReset () {
      this.list = DEF_LIST;
      this.resetFont();
      this.defaultFontColor = false;
    },
    onKeydownC (ev) {
      if (ev.key === 'Control') {
        this.ctrlPressed = true;
      }
      if (ev.key === 'Shift') {
        this.shiftPressed = true;
      }
    },
    onKeyupC (ev) {
      if (ev.key === 'Control') {
        this.ctrlPressed = false;
      }
      if (ev.key === 'Shift') {
        this.shiftPressed = false;
      }
    },
    onEnter (ev) {
      ev.target.blur();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 620px;
}
.list {
  width: 620px;

  &__row {
    display: flex;
    height: 36px;
    line-height: 36px;
    border-bottom: solid 1px #d9ddea;

    &.active {
      background: #f9f9fc;
    }

    &.y-1 {
      transform: translatey(1px);
    }
  }

  &__col {
    position: relative;
    height: 36px;
    text-align: left;
    padding-left: 1em;
    border-right: solid 1px #d9ddea;

    &:last-of-type {
      border-right-width: 0;
      &.active {
        border-right-width: 0;
      }
    }

    &:nth-of-type(1) {
      width: 253px;
    }
    &:nth-of-type(2) {
      width: 88px;
    }
    &:nth-of-type(3) {
      width: 109px;
    }
    &:nth-of-type(4) {
      width: 174px;
    }

    &.active {
      border-right: 1px solid #5778fb;
    }
  }

  &__input {
    position: absolute;
    top: -1px;
    left: -1px;
    height: 36px;
    text-align: left;
    padding-left: 1em;
    border: none;
    background-color: transparent;
    cursor: pointer;

    &:focus {
      border: 1px solid #5778fb;
    }

    &.key-text {
      width: 252px;
      margin-left: 1px;
    }
    &.key-size {
      width: 88px;
    }
    &.key-color {
      width: 109px;
    }
    &.key-font {
      width: 172px;
      cursor: default;
    }

    &.color-active {
      caret-color: transparent;
      cursor: default;
      color: transparent;
    }
  }

  &__header {
    background-color: #e8e8ef;
  }

  &__content {
    height: 424px;
    overflow-y: auto;
  }

  &__color {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 107px;
    height: 34px;
    line-height: 16px;
    background-color: transparent;

    & > div {
      position: absolute;
      top: 9px;
      left: 15px;
      width: 58px;
      height: 16px;
      line-height: 16px;
      background-color: #e73187;
      border: solid 1px #d9ddea;
    }

    &.disabled {
      cursor: not-allowed;
    }
  }
}

.hr {
  width: 610px;
  height: 2px;
  background-color: #f0f0f8;
  margin: auto;
}

.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 57px;
  padding-right: 0.4em;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 80px;
  max-width: 120px;
  height: 34px;
  line-height: 34px;
  background-color: #f4f4f8;
  border-radius: 4px;
  border: solid 1px #d9ddea;
  padding-left: 1.2em;
  padding-right: 1.2em;
  margin-right: 0.8em;

  & > .icon {
    width: 14px;
    height: 14px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-right: 5px;
  }
}

.icon-file {
  background-image: url(../../../../static/svg/word-cloud/file.svg);
}
.icon-add {
  background-image: url(../../../../static/svg/word-cloud/add.svg);
}
.icon-delete {
  background-image: url(../../../../static/svg/word-cloud/delete.svg);
}
.icon-reset {
  background-image: url(../../../../static/svg/word-cloud/swap.svg);
}

.font-thumb-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background-color: #fff;
}
.font-thumb {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 0;
  margin: auto;
  width: auto;
  height: auto;
  max-width: 90%;
  max-height: 90%;
}

.triangle-icon {
  position: absolute;
  right: 1em;
  top: 50%;
  transform: translateY(-50%);

  display: inline-block;
  width: 10px;
  height: 6px;
  background: url('../../../../static/svg/inverted-triangle.svg') no-repeat
    center;
  // &:hover {
  //   background: url('../../../../static/svg/inverted-triangle-active.svg') no-repeat center;
  // }
}

.list__content {
  & .list__row:nth-child(1) {
    transform: translateY(1px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/wordCloud/textControl.vue